import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { inject, observer } from "mobx-react";
import * as React from "react";
import { ITest } from "src/Interfaces/TestInterface";
import { IWell } from "src/Interfaces/WellInterface";
import PdfService from "src/Services/Pdf";
import TenantStore from "src/Stores/Tenant/TenantStore";
import { TestsStore } from "src/Stores/Tests/TestsStore";
import { UserStore } from "src/Stores/User/UserStore";
import { WellsStore } from "src/Stores/Wells/WellsStore";

@inject('stores')
@observer
export default class MudReportPdf extends React.Component {
    public props: any;
    private test: ITest;
    public TestsStore: TestsStore;
    private well: IWell;
    public WellsStore: WellsStore;
    public UserStore: UserStore;
    public TenantStore: TenantStore;
    
    public state = {
        test: this.test,
        testList: [] as ITest[],
        tests: [] as ITest[],
        testsToDisplay: [] as ITest[],
        well: this.well
    };

    constructor(props: any) {
        super(props);

        this.TestsStore = this.props.stores.TestsStore;
        this.WellsStore = this.props.stores.WellsStore;
        this.UserStore = this.props.stores.UserStore;
        this.TenantStore = this.props.stores.TenantStore;
    }
    
    public componentDidMount() {
        this.UserStore.getProfile().then(() => {
            if (this.props.match.params.taskId === 'all') {
                this.getAllTestsData();
            } else if(this.props.match.params.taskId === 'multiple'){
                this.getAllTestsDataReport()
                .then(() => this.getTestsToDisplay());
            } else {
                this.getTestData();
                if (this.UserStore.hasGenericPermission('Permissions.Reports.System.View')) {
                    this.getAllTestsDataReport();
                } else {
                    this.getTestList();
                }
            }
            if (this.UserStore.hasGenericPermission('Permissions.Reports.System.View')) {
                this.getWellDataReport();
            } else {
                this.getWellData();
            }
        });
    }

    public componentDidUpdate() {
        this.renderIframe();
    }

    private getTestData() {
        return this.TestsStore.getTestDetailsReport(this.props.match.params.taskId, this.props.match.params.wellId)
        .then(
            (data: any) => {
                this.setState({
                    test: data
                });
            }
        );
    }

    private getAllTestsDataReport() {
        return this.TestsStore.getAllTestsDetailsReport(this.props.match.params.wellId)
        .then(
            (data: any) => {
                this.setState({
                    testList: data,
                    tests: data,
                });
            }
        );
    }

    private getAllTestsData() {
        return this.TestsStore.getAllTestsDetails(this.props.match.params.wellId)
        .then(
            (data: any) => {
                this.setState({
                    tests: data,
                });
            }
        );
    }

    private getWellDataReport() {
        return this.WellsStore.getWellReport(this.props.match.params.wellId)
        .then(
            (data: any) => {
                this.setState({
                    well: data
                });
            }
        );
    }

    private getWellData() {
        return this.WellsStore.getWellDetails(this.props.match.params.wellId)
        .then(
            (data: any) => {
                this.setState({
                    well: data
                });
            }
        );
    }
    
    private getTestList() {
        return this.TestsStore.getTests(this.props.match.params.wellId)
        .then(
            (data: any) => {
                this.setState({
                    testList: data,
                });
            }
        );
    }

    private renderIframe() {
        const myFrame: any = document.getElementById('my_frame');
        if (myFrame) {
            this.pdfReportBlob().then(data =>
                myFrame.src = data
            );
        }
    }
    private getTestsToDisplay() {
        const urlSearchString = (this.props.location.search).slice(1);
        const testIdList = urlSearchString.split(",");
        let testsToDisplay: ITest[] = [];
        testsToDisplay = this.state.tests.filter((test) => testIdList.includes(test.id));
        this.setState({
            testsToDisplay
        });
    }

    private pdfReportBlob = () => {
        if (this.props.match.params.taskId === 'all') {
            return PdfService.createMudPdfAll(this.state.tests, this.state.well, this.TenantStore.logoPathNameReport);
        } else if (this.props.match.params.taskId === 'multiple') {
            return PdfService.createMudPdfForMultipleTests(this.state.testsToDisplay, this.state.tests, this.state.well, this.TenantStore.logoPathNameReport);
        }

        const preview = !(this.UserStore.isNotMudEngineer() || this.state.test.testStatus === 'Approved');
        return PdfService.createMudPdf(this.state.test, this.state.well, this.TenantStore.logoPathNameReport, preview);
    }

    public render() {
        if (((this.props.match.params.taskId === 'all' && this.state.tests.length === 0) || (this.props.match.params.taskId === 'multiple' && this.state.testsToDisplay.length === 0) ) || this.state.well === undefined || this.UserStore.user === undefined) {
            return (
                <FontAwesomeIcon 
                icon={faSpinner}
                spin={true}
                size={"8x"}
                style={{position: 'fixed', left: '50%', top: '35%'}}
            />
            );
        } else if(this.props.match.params.taskId !== 'all' && this.props.match.params.taskId !== 'multiple' && ( this.state.test === undefined || (this.state.testList && this.state.testList.length === 0))) {
            return (
                <FontAwesomeIcon 
                icon={faSpinner}
                spin={true}
                size={"8x"}
                style={{position: 'fixed', left: '50%', top: '35%'}}
            />
            );
        }
        return (
            <iframe id="my_frame" style={{width: '100%', height: '100vh'}} />
        );
    }


}


// WEBPACK FOOTER //
// ./src/Components/Reporting/MudReportPdf.tsx